/* eslint-disable complexity */
/* eslint-disable max-lines-per-function */
/* eslint-disable no-irregular-whitespace */
import { bytesToNDigits } from '@mail/cross-sizes-utils';
import { Icon24ArrowLeftOutline } from '@vkontakte/icons';
import { IconButton, Text } from '@vkontakte/vkui';
import classNames from 'clsx';
import { ReactComponent as IconClose } from 'img/icons/close_s__2.svg';
import { path } from 'ramda';
import React, { PureComponent } from 'react';
import { connect } from 'react-redux';
import { PROMO_TARIFFS } from 'reactApp/appHelpers/configHelpers';
import { emitAnalyticEvent } from 'reactApp/appHelpers/experimentAnalytic';
import { AnalyticEventNames } from 'reactApp/appHelpers/experimentAnalytic/eventNames';
import { tariffBuyCustomDescription, tariffBuyCustomTitle, trialPrice } from 'reactApp/appHelpers/featuresHelpers';
import { dmrMidasBuyEnabled, dmrMidasTrialTouch } from 'reactApp/appHelpers/featuresHelpers/features/dmrMidas';
import { ImapTariffsList } from 'reactApp/appHelpers/featuresHelpers/features/ImapSubscription';
import { MultiSessionDeviceSubs } from 'reactApp/appHelpers/featuresHelpers/features/multiSessionSubscriptions';
import { upgradeSubscriptionEnabled } from 'reactApp/appHelpers/featuresHelpers/features/upgradeSubscription';
import { vigboTariffs } from 'reactApp/appHelpers/featuresHelpers/features/vigbo';
import { getQueryParams } from 'reactApp/appHelpers/settingsHelpers';
import { BillingActions } from 'reactApp/modules/billing/billing.module';
import { BillingSelectors } from 'reactApp/modules/billing/billing.selectors';
import { PaymentWindowType } from 'reactApp/modules/payment/payment.analytics';
import { getMultiSessionFreeChoiceDescription, getMultiSessionPresetInSubsDescription } from 'reactApp/modules/payment/payment.helpers';
import { ProductsSelectors } from 'reactApp/modules/products/products.selectors';
import { UserSelectors } from 'reactApp/modules/user/user.selectors';
import { EPostMessageBuy } from 'reactApp/sections/MobileSubscriptionsPage/MobileSubscriptionsPage.types';
import type { Product } from 'reactApp/types/Billing';
import type { SpecialTariffProps } from 'reactApp/types/SpecialTariffProps';
import { Dialog } from 'reactApp/ui/Dialog/Dialog';
import { DMR } from 'reactApp/ui/DMRFrame/DMR';
import { PaymentFooter } from 'reactApp/ui/PaymentFooter/PaymentFooter';
import { noop } from 'reactApp/utils/helpers';
import { EPaymentGa, sendPaymentGa } from 'reactApp/utils/paymentGa';
import { getPeriodName } from 'reactApp/utils/Period';
import { formatPrice } from 'reactApp/utils/priceHelpers';
import { sendTmrGoal } from 'reactApp/utils/tmr';
import { getParameterFromUrl } from 'reactApp/utils/urlHelper';
import { sendPostMessage } from 'reactApp/utils/windowHelper';
import type { AnyAction } from 'redux';

import styles from './TariffBuy.css';

interface Props extends SpecialTariffProps {
    link: string | null;
    isLoading: boolean;
    hasError: boolean;
    isMobile: boolean;
    hasTrial: boolean;
    reset();
    buy(...args);
    id: Product['id'];
    product?: Product;
    onSuccess();
    onClose();
    onError();
    userTotalSpace: Product['space'];
    source?: string;
    isQuotaCleaner?: boolean;
    closable?: boolean;
    title?: string;
    isMidas?: boolean;
    isBytePromo?: boolean;
    paymentDescription?: string;
    eventCategory?: string;
    paySource?: string;
    onClick();
    subTitle?: string;
    onPayBtnClick?: () => void;
    isAlmostFullFreeUser?: boolean;
    showBackButton?: boolean;
    onBackButtonClick?: () => void;
    linkForUpgrade?: string;
}

interface State {
    isOpen: boolean;
    isSuccessPayment: boolean;
    frameHeight: number;
    orderAmount: string | null;
}

const mapStateToProps = (state, props): any => {
    const { isMobile, linkForUpgrade } = props;

    const product = props.product || ProductsSelectors.getProductById(state, props.id) || {};
    const { space, period, price, hasTrial } = product;

    const { total: userTotalSpace } = UserSelectors.getCloudSpace(state);

    const { isLoading, hasError } = BillingSelectors.getLoadingState(state);
    const buyLink = upgradeSubscriptionEnabled && linkForUpgrade ? linkForUpgrade : BillingSelectors.getPaymentLink(state);

    // если это триал на таче и включена фича и открыто с utm онбординга, то окно с мидасом
    const isTouchTrialMidas = isMobile && hasTrial && dmrMidasTrialTouch;
    // если все кроме триала, то смотри на фичу dmrMidasBuyEnabled
    const isBuyMidas = !hasTrial && dmrMidasBuyEnabled;

    return {
        product,
        link: buyLink,
        space,
        period,
        isLoading,
        hasError,
        price,
        userTotalSpace,
        hasTrial,
        isMidas: isTouchTrialMidas || isBuyMidas,
        isBytePromo: product.id === PROMO_TARIFFS?.bytePromo,
        isAlmostFullFreeUser: UserSelectors.isAlmostFullFreeUser(state),
    };
};

const mapDispatchToProps = (dispatch, props) => ({
    buy: (id: string, source, isMidas, description): AnyAction => {
        const { isMobile, paySource } = props;

        return dispatch(
            BillingActions.buySubscription({
                id,
                isMobile,
                source,
                xraySource: 'tariff-modal',
                description,
                isMidas,
                paySource,
            })
        );
    },
    reset: (): AnyAction => dispatch(BillingActions.resetLink()),
});

class TariffBuy extends PureComponent<Props, State> {
    public state = {
        isOpen: true,
        isSuccessPayment: false,
        frameHeight: 0,
        orderAmount: null,
    };

    public static defaultProps = {
        onSuccess: noop,
        onClose: noop,
        onError: noop,
        closable: true,
        onClick: noop,
    };

    public componentDidMount(): void {
        const { id, paySource, product, isAlmostFullFreeUser, isMidas } = this.props;
        this.handleBuy(id);
        emitAnalyticEvent(AnalyticEventNames.FAST_CHECKOUT_SHOWN, {
            paySource,
            product,
            productId: id,
            enabledMidasPayment: isMidas,
            isAlmostFullFreeUser,
        });
        this.sendPayment('view');

        if (this.props.isMobile) {
            sendPostMessage({
                loadResult: EPostMessageBuy.WINDOW_LOAD_SUCCESS,
            });
        }
    }

    public componentDidUpdate(prevProps: Props): void {
        const { hasError, onError, link } = this.props;

        if (!prevProps.hasError && hasError) {
            onError();
        }

        if (link !== prevProps.link && link) {
            this.setState({ orderAmount: getParameterFromUrl(link, 'order_amount') });
        }
    }

    sendPayment = (label, payMethod = undefined) => {
        const { id, paySource } = this.props;

        sendPaymentGa({ action: EPaymentGa.payment, label: `${label}_v2`, tariff: id, paySource, paymethod: payMethod });
    };

    private handleOnClose = (): void => {
        const { onClose } = this.props;

        onClose();

        this.setState({
            isOpen: false,
        });
    };

    private handleOnCancelDialog = (): void => {
        const { product } = this.props;
        this.handleOnClose();
        if (product) {
            emitAnalyticEvent(AnalyticEventNames.TARIFF_CLOSE, { product });
        }
        this.sendPayment('close');
    };

    private handleBackClick = (): void => {
        const { onBackButtonClick, product } = this.props;
        this.handleOnClose();
        onBackButtonClick?.();
        if (product) {
            emitAnalyticEvent(AnalyticEventNames.TARIFF_BACK_CLICK, { product });
        }
        this.sendPayment('click_back');
    };

    private handleDmrFormSend = (): void => {
        const { onClick, isMidas, onPayBtnClick } = this.props;

        if (isMidas) {
            return;
        }

        onPayBtnClick?.();
        this.sendPayment('click');
        onClick();
    };

    private handlePayClick = ({ method }): void => {
        const { onClick, isMidas, paySource, product } = this.props;

        if (!isMidas) {
            return;
        }

        if (product) {
            emitAnalyticEvent(AnalyticEventNames.TARIFF_BUY, { paySource, product, enabledMidasPayment: isMidas });
        }
        this.sendPayment('click', method);

        onClick();
    };

    private handleOnSuccess = (): void => {
        const { onSuccess, hasTrial } = this.props;

        sendTmrGoal({ goal: hasTrial ? 'trial-success' : 'pay-success' });

        this.setState({ isSuccessPayment: true }, () => {
            onSuccess();
        });
    };

    private handleError = (): void => {
        this.props.onError();
    };

    private handleResize = (data): void => {
        const newHeight = path(['height'], data) as number;
        const { frameHeight } = this.state;
        if (newHeight && frameHeight !== newHeight) {
            this.setState({ frameHeight: newHeight });
        }
    };

    private handleBuy = (productId) => {
        const { buy, source, isMidas, linkForUpgrade } = this.props;

        if (linkForUpgrade) {
            return;
        }

        buy(productId, source, isMidas, this.getPaymentDescription());
    };

    private handleDmrLoad = (isSuccess) => {
        if (this.props.isMobile) {
            sendPostMessage({
                loadResult: isSuccess ? EPostMessageBuy.LOAD_DMR_SUCCESS : EPostMessageBuy.LOAD_DMR_ERROR,
            });
        }
    };

    private getPaymentDescription = () => {
        const { action = null, description = null } = getQueryParams();
        const descriptionFromQuery =
            action === 'request-payment' && tariffBuyCustomDescription?.hasOwnProperty(description)
                ? tariffBuyCustomDescription[description]
                : undefined;

        if (descriptionFromQuery) {
            return descriptionFromQuery;
        }

        const { paymentDescription, product, isMidas, isMobile } = this.props;

        if (product && ImapTariffsList.includes(product.id)) {
            const isMonthly = product.period === '1m';
            return `${isMonthly ? 'В месяц' : 'В год'} — любое количество паролей для внешних приложений`;
        }

        /* tempexp_20439-start */
        if (product?.id && MultiSessionDeviceSubs.enabled) {
            if (MultiSessionDeviceSubs.isFreeChoiceProduct(product.id)) {
                return getMultiSessionFreeChoiceDescription(product);
            }
            if (MultiSessionDeviceSubs.isPresetInSubsProdcut(product.id)) {
                return getMultiSessionPresetInSubsDescription(product);
            }
        }
        /* tempexp_20439-end */
        if (product?.id && vigboTariffs.includes(product.id)) {
            return `${product.space.value} в Облаке, галереи Vigbo и все возможности Mail Space`;
        }

        if (paymentDescription) {
            return paymentDescription;
        }

        if (product && product?.isFamily && product?.isOnlyFeatures && !product?.hasTrial) {
            return `Семейные функции на ${getPeriodName(product.discountPeriod || product.period, false, true)}`;
        }

        if (isMobile && isMidas && product && product.hasTrial) {
            return 'Для проверки карты мы спишем и сразу же вернем 1 ₽';
        }
    };

    private getHeader() {
        const { isSuccessPayment } = this.state;

        const { space, period, userTotalSpace, isMobile, hasTrial, price, product, title, subTitle, isBytePromo } = this.props;
        const { hasDiscount, discountPrice, discountPeriod, trialPeriod, isForceDiscountTrial } = product || {};

        const { title: titleFromQuery = null, action = null, fastcheckoutTitle = null } = getQueryParams();

        if (product && ImapTariffsList.includes(product.id)) {
            return 'Создание паролей для приложений';
        }

        if (product?.id && vigboTariffs.includes(product?.id)) {
            const trialPeriodName = product.hasTrial && product.trialPeriod && getPeriodName(product.trialPeriod, false, true);

            const vigboTitle = product?.hasTrial
                ? `Подписка для фотографов Mail Space и Vigbo на ${trialPeriodName} бесплатно`
                : 'Подписка для фотографов Mail Space и Vigbo';

            const vigboSubTitle = 'Единая подписка на два сервиса для работы фотографа';

            return (
                <>
                    {vigboTitle}
                    <span className={styles.subtitle}>{vigboSubTitle}</span>
                </>
            );
        }

        if (product?.isFamily && product.isOnlyFeatures) {
            return 'Подключить семейные функции';
        }

        if (isBytePromo && space && trialPeriod) {
            return `${space.value} на ${getPeriodName(trialPeriod, true)} бесплатно`;
        }

        const customTitle = fastcheckoutTitle || titleFromQuery;
        if (action === 'request-payment' && tariffBuyCustomTitle?.hasOwnProperty(customTitle)) {
            return tariffBuyCustomTitle[customTitle];
        }

        if (title && subTitle) {
            return (
                <>
                    {title}
                    {Boolean(subTitle) && <span className={styles.subtitle}>{subTitle}</span>}
                </>
            );
        }

        if (title) {
            return title;
        }

        if (isSuccessPayment) {
            return 'Оплата прошла успешно';
        }

        if (isMobile && space) {
            if (isForceDiscountTrial) {
                return <>Подписка Mail&nbsp;Space {space.value}</>;
            }

            const priceToDisplay = hasDiscount ? discountPrice : price;
            const periodToDisplay = hasDiscount && discountPeriod ? discountPeriod : period;

            const priceText = priceToDisplay ? ` за ${formatPrice(priceToDisplay)} ₽` : '';

            return hasTrial ? (
                `Введите данные карты для получения ${space.value}${trialPeriod ? ` на ${getPeriodName(trialPeriod, false, true)}` : ''}`
            ) : (
                <>
                    Оплата тарифа
                    <br />
                    {space.value} на {getPeriodName(periodToDisplay, false, true)}
                    {priceText}
                    {Boolean(subTitle) && <span className={styles.subtitle}>{subTitle}</span>}
                </>
            );
        }

        if (userTotalSpace && space) {
            const newSpace = bytesToNDigits(userTotalSpace.original + space.original, 3).value;
            return (
                <>
                    Увеличение объёма до {newSpace}
                    {Boolean(subTitle) && <span className={styles.subtitle}>{subTitle}</span>}
                </>
            );
        }

        return 'Подписка на Облако';
    }

    private renderHeader = (): JSX.Element | null => {
        return (
            <div className={styles.headerContainer}>
                {this.props.showBackButton && (
                    <IconButton data-qa-id="back" hasHover={false} onClick={this.handleBackClick} aria-label="Назад">
                        <Icon24ArrowLeftOutline className={styles.backIcon} />
                    </IconButton>
                )}
                <div>{this.getHeader()}</div>
            </div>
        );
    };

    private getDescription() {
        const { product, isBytePromo } = this.props;

        if (isBytePromo && product?.discountPeriod) {
            return (
                <div className={styles.description}>
                    Затем {formatPrice(product.discountPrice)}&nbsp;₽ за&nbsp;
                    {getPeriodName(product.discountPeriod)}
                </div>
            );
        }

        if (product?.isForceDiscountTrial && product?.trialPeriod && product?.discountPeriod) {
            return (
                <div className={styles.description}>
                    {getPeriodName(product.trialPeriod, true)} бесплатно, затем {formatPrice(product.discountPrice)}&nbsp;₽ за&nbsp;
                    {getPeriodName(product.discountPeriod)}
                </div>
            );
        }

        return null;
    }

    public render() {
        const { isSuccessPayment, isOpen, frameHeight, orderAmount } = this.state;

        if (!isOpen) {
            return null;
        }

        const {
            isLoading,
            reset,
            product,
            hasError,
            link,
            isMobile,
            id,
            hasTrial,
            isQuotaCleaner,
            closable,
            isMidas,
            eventCategory,
            paySource,
        } = this.props;

        const defaultEventCategory = isMidas ? 'midasBuyModal' : 'newBuyModal';
        const isMobileMidas = isMobile && isMidas;

        return (
            <Dialog
                id="tariff-buy"
                open
                size="larger"
                header={isMobileMidas ? '' : this.renderHeader()}
                onCancel={this.handleOnCancelDialog}
                mod={isMobile ? 'mobile' : 'frame'}
                closeOnDimmerClick={false}
                closeOnEscape={false}
                dimmer={!isMobile}
                showCloseIcon={!isMobileMidas}
                disableScrollOnBody={!isQuotaCleaner}
                closable={closable}
                disableDarkTheme
                className={classNames({
                    [styles.midasModal]: isMidas,
                    [styles.mobileModal]: isMobile,
                })}
            >
                {!isMobileMidas && this.getDescription()}
                <div
                    className={classNames(styles.root, {
                        [styles.root_mobile]: isMobile,
                        [styles.root_trial]: hasTrial && !isMidas,
                        [styles.root_midasMobile]: isMobileMidas,
                    })}
                >
                    {hasTrial && !!link && !isMidas && (
                        <Text className={styles.note} data-qa-id="note-check-payment">
                            Для проверки карты мы спишем и сразу же вернём&nbsp;{formatPrice(parseInt(orderAmount || '0') || trialPrice)}
                            &nbsp;₽.
                        </Text>
                    )}
                    {isMobileMidas && (
                        <div>
                            <div className={styles.headerBlock}>
                                <div className={styles.header}>{this.getHeader()}</div>
                                {closable && (
                                    <div className={styles.closeIcon} onClick={this.handleOnClose}>
                                        <IconClose />
                                    </div>
                                )}
                            </div>
                            {this.getDescription()}
                        </div>
                    )}
                    <div style={frameHeight && !isMidas ? { height: frameHeight } : {}} className={classNames(styles.dmrContainer)}>
                        <DMR
                            buySubscription={this.handleBuy}
                            resetSubscription={reset}
                            subscription={product}
                            onCancel={this.handleOnClose}
                            onSuccess={this.handleOnSuccess}
                            onFormSend={this.handleDmrFormSend}
                            onPayClick={this.handlePayClick}
                            isLoading={isLoading}
                            hasError={hasError}
                            onError={this.handleError}
                            onResize={this.handleResize}
                            onDmrLoad={this.handleDmrLoad}
                            checkoutLink={link}
                            className={styles.dmr}
                            disableLoaderCentering
                            eventCategory={eventCategory || defaultEventCategory}
                            size={isMobile ? 'medium' : 'larger'}
                            skin="vkpay"
                            isMidas={isMidas}
                            paySource={paySource}
                            windowType={PaymentWindowType.default}
                        />
                    </div>
                    <div
                        className={classNames(styles.footer, {
                            [styles.footer_success]: isMobile && isSuccessPayment,
                        })}
                    >
                        <PaymentFooter productId={id} isMobile={isMobile} product={this.props.product} />
                    </div>
                </div>
            </Dialog>
        );
    }
}

export default TariffBuy;

export const TariffBuyConnected = connect(mapStateToProps, mapDispatchToProps)(TariffBuy);
